import React from 'react'
import {
  Row, Col,
} from 'reactstrap'
import Spinner from 'components/common/Loader'
import { chartColors } from 'components/charts/colors'
import { gql, useQuery } from '@apollo/client'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Query } from 'generated/types'
import {
  SecondaryCard, SecondaryCardBody, SecondaryCardTitle, SecondaryCardSubtitle,
} from './ChartCard'

const AVERAGE_CONTACTS_PER_CASE_COUNT = gql`
  query AverageContactsPerCaseCount {
    chart {
      averageContactsPerCase
    }
  }
`

const AverageContactsPerCaseCard: React.FC = (props) => {
  return (
    <SecondaryCard className="mb-4">
      <SecondaryCardBody className="rounded-soft">
        <Row className="align-items-center no-gutters">
          <Col xs="1">
            <FontAwesomeIcon
              icon="shield-alt"
              transform="grow-4"
            />
          </Col>
          <Col xs="11">
            <SecondaryCardTitle>{props.children}</SecondaryCardTitle>
          </Col>
        </Row>
        <SecondaryCardSubtitle className="mb-1">Average Contacts Per Case</SecondaryCardSubtitle>
      </SecondaryCardBody>
    </SecondaryCard>
  )
}

export const AverageContactsPerCase = () => {
  const { data, loading, error } = useQuery<Query>(AVERAGE_CONTACTS_PER_CASE_COUNT, {})

  if (loading) {
    return (
      <AverageContactsPerCaseCard>
        <Spinner color="light" />
      </AverageContactsPerCaseCard>
    )
  }

  if (error) {
    return (
      <AverageContactsPerCaseCard>
        <div className="d-flex justify-content-center">
          <FontAwesomeIcon
            icon="exclamation-triangle"
            color={chartColors.medium}
            transform="grow-30"
            className="mt-3"
          />
        </div>
        <div className="mt-4 text-center fs--1">
          <p>There was an error fetching the average contacts per case data</p>
        </div>
      </AverageContactsPerCaseCard>
    )
  }

  return (
    <AverageContactsPerCaseCard>
      {data?.chart.averageContactsPerCase}
    </AverageContactsPerCaseCard>
  )
}
